/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

module.exports = { "default": require("core-js/library/fn/map"), __esModule: true };



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/core-js/map.js
 ** module id = 85
 ** module chunks = 0
 **/